<template>

	<div class="form-group" :class="{ 'has-error': errors.has('recipients-group') }">

		<label for="recipients-group" class="control-label">{{ label }}</label>

		<select id="recipients-group" name="recipients-group" class="form-control" v-model="recipientGroup" v-validate="{ 'required': required }" :required="required"  @change="changed">
			<option value="" v-translate>Selecione</option>
			<option v-for="(option, index) in ENUM.RecipientsGroupType" :value="index">{{ option }}</option>
		</select>

	</div>

</template>

<script>

	import RecipientsGroup from './';
	export default RecipientsGroup;

</script>




// WEBPACK FOOTER //
// main.vue?7df048b4